import { Link } from "react-router-dom";
import { pricingTable } from "@/mocks/updiag";

export default function PricingSection() {
  return (
    <section className="bg-white py-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-[#F97316] text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
            Tarifs transparents
          </span>
          <h2 className="text-4xl font-extrabold text-[#0F3B5F] mb-4" style={{ fontFamily: "Barlow, sans-serif" }}>
            Nos prix affichés sans surprise
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            Tous nos tarifs sont TTC, déplacement inclus en Île-de-France. Devis personnalisé gratuit en 2 minutes.
          </p>
        </div>

        <div className="rounded-2xl border border-gray-100 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="bg-[#0F3B5F] text-white">
                <th className="text-left px-6 py-4 text-sm font-bold" style={{ fontFamily: "Barlow, sans-serif" }}>Service</th>
                <th className="text-left px-6 py-4 text-sm font-bold hidden md:table-cell">Description</th>
                <th className="text-right px-6 py-4 text-sm font-bold">Prix TTC</th>
              </tr>
            </thead>
            <tbody>
              {pricingTable.map((row, i) => (
                <tr
                  key={i}
                  className={`border-b border-gray-50 transition-colors hover:bg-orange-50/50 ${
                    row.highlight ? "border-l-4 border-l-[#F97316]" : ""
                  } ${i % 2 === 0 ? "bg-white" : "bg-gray-50/50"}`}
                >
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <span className={`text-sm font-bold ${row.highlight ? "text-[#F97316]" : "text-[#0F3B5F]"}`}>
                        {row.service}
                      </span>
                      {row.highlight && (
                        <span className="bg-orange-100 text-[#F97316] text-[10px] font-bold px-2 py-0.5 rounded-full">★ Phare</span>
                      )}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-500 hidden md:table-cell">{row.description}</td>
                  <td className="px-6 py-4 text-right">
                    <span className="text-lg font-extrabold text-[#0F3B5F]" style={{ fontFamily: "Barlow, sans-serif" }}>{row.price}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 bg-[#F8FAFC] rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-bold text-[#0F3B5F]" style={{ fontFamily: "Barlow, sans-serif" }}>Besoin d'un devis personnalisé ?</p>
            <p className="text-sm text-gray-500">Tarif adapté à votre bien, votre surface et votre commune.</p>
          </div>
          <Link
            to="/devis"
            className="flex items-center gap-2 px-7 py-3.5 bg-[#F97316] text-white rounded-xl font-bold hover:bg-orange-600 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-file-list-3-line"></i>
            Devis gratuit en 2 min
          </Link>
        </div>
      </div>
    </section>
  );
}
